import {ssrSafeLocation} from '@github-ui/ssr-utils'

import buyMeACoffeeIcon from '../assets/buy_me_a_coffee.svg'
import communityBridgeIcon from '../assets/community_bridge.svg'
import issueHuntIcon from '../assets/issuehunt.svg'
import koFiIcon from '../assets/ko_fi.svg'
import liberapayIcon from '../assets/liberapay.svg'
import openCollectiveIcon from '../assets/open_collective.svg'
import patreonIcon from '../assets/patreon.svg'
import polarIcon from '../assets/polar.svg'
import thanksDevIcon from '../assets/thanks_dev.svg'
import tideliftIcon from '../assets/tidelift.svg'

import type {PlatformType} from '../types'

/** Human-readable labels for funding platforms. */
export const platformLabels: Record<PlatformType, string> = {
  github: 'GitHub Sponsors',
  patreon: 'Patreon',
  open_collective: 'Open Collective',
  ko_fi: 'Ko-fi',
  tidelift: 'Tidelift',
  community_bridge: 'LFX Mentorship',
  liberapay: 'Liberapay',
  issuehunt: 'IssueHunt',
  lfx_crowdfunding: 'LFX Crowdfunding',
  polar: 'Polar',
  buy_me_a_coffee: 'Buy Me a Coffee',
  thanks_dev: 'thanks.dev',
  custom: 'Custom',
}

/** Returns a human-readable label for a funding platform identifier. */
export function getPlatformLabel(platform: PlatformType): string {
  return platformLabels[platform] ?? platform
}

const platformIconMap: Record<PlatformType, string | null> = {
  buy_me_a_coffee: buyMeACoffeeIcon,
  community_bridge: communityBridgeIcon,
  github: null,
  ko_fi: koFiIcon,
  liberapay: liberapayIcon,
  lfx_crowdfunding: null,
  open_collective: openCollectiveIcon,
  polar: polarIcon,
  tidelift: tideliftIcon,
  patreon: patreonIcon,
  issuehunt: issueHuntIcon,
  thanks_dev: thanksDevIcon,
  custom: null,
}

export function getPlatformIconPath(platform: PlatformType): string | null {
  return platformIconMap[platform] ?? null
}

/**
 * Splits a funding URL into a prefix and an emphasized tail segment.
 * Used to visually highlight the unique part of external funding links.
 */
export function formatExternalLink(url: string): {prefix: string; emphasized?: string} {
  try {
    const parsed = new URL(url, ssrSafeLocation.origin)
    const host = parsed.host.replace(/^www\./, '')
    const segments = parsed.pathname.split('/').filter(Boolean)

    if (segments.length === 0) {
      return {prefix: host}
    }

    if (segments.length === 1) {
      return {prefix: `${host}/`, emphasized: segments[0]}
    }

    const tail = segments[segments.length - 1]
    const leading = segments.slice(0, -1).join('/')
    return {prefix: `${host}/${leading}/`, emphasized: tail}
  } catch {
    return {prefix: url}
  }
}
